<div *ngIf="droitModif || !empty">
  <div class="header-class">
    {{projetSchemaDescr.libelle}}
    <div>
    <button color="success" mat-raised-button type="button" [disabled]="!droitModif" matTooltip="Vous n’avez pas les droits pour modifier ce formulaire" [matTooltipDisabled]="droitModif" (click)="onclickButton()">
      <mat-icon>edit</mat-icon>Modification
    </button>
    <mat-icon [matTooltip]="emailModifieursTxt" matTooltipClass="multiline-tooltip">info</mat-icon>
  </div>
  </div>
  <div class="data-class row">
    <div class="col-sm-12">
        <form [formGroup]="form">
          <formly-form
            [form]="form"
            [fields]="schema"
            [model]="model"
            (modelChange)="modelChanges($event)">
          </formly-form>
        </form>
    </div>
  </div>
</div>